import { zodResolver } from "@hookform/resolvers/zod";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { useAddUser } from "@/api/user/add-new-user";
import { Button } from "@/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";
import useOnboardingData from "@/store/onboarding-data";
import useGlobalLoading from "@/store/global-loading";
// import { useUpdatePermission } from "@/api/permissions/update-permission";

const formSchema = z.object({
    firstname: z
        .string({
            required_error: "Firstname is required",
            invalid_type_error: "Firstname must be a string",
        })
        .min(2, { message: "Firstname must have at least 2 characters" })
        .max(20, { message: "Firstname must not have more than 20 characters" }),
    lastname: z
        .string({
            required_error: "Lastname is required",
            invalid_type_error: "Lastname must be a string",
        })
        .min(2, { message: "Lastname must have at least 2 characters" })
        .max(20, { message: "Lastname must not have more than 20 characters" }),
    heared_from: z.string({
        required_error: "Please select a source.",
    }),
    prev_bot: z.string().optional(),
});

const UserInfoForm = () => {
    const [isPrevBot, setIsPrevBot] = React.useState("no");

    const form = useForm<z.infer<typeof formSchema>>({
        resolver: zodResolver(formSchema),
        defaultValues: {
            firstname: "",
            lastname: "",
        },
    });

    const { mutate: addUser, isPending: isAddUserPending, isSuccess } = useAddUser();

    const { user: kindeUser, isLoading: kindeLoading } = useKindeAuth();

    // const { mutate: addPermission } = useUpdatePermission();

    const { storeData } = useOnboardingData();

    function onSubmit(values: z.infer<typeof formSchema>) {
        addUser({
            name: `${values?.firstname} ${values.lastname}`,
            store_id: storeData?.id,
            email: kindeUser?.email || "",
            heard_from: values.heared_from,
            isPrevBot: isPrevBot === "yes",
            prev_bot: values.prev_bot,
        });
        setIsLoading(true);
    }

    // useEffect(() => {
    //     if (isSuccess) {
    //         addPermission({
    //             data: [
    //                 {
    //                     module_id: "b9631bfd-a13f-40eb-b4b2-a77a13cd3a15",
    //                     user_id: userData?.data?.id || kindeUser?.id,
    //                     can_get_list: true,
    //                     can_get_one: true,
    //                     can_create: true,
    //                     can_update: true,
    //                     can_delete: true,
    //                 },
    //                 {
    //                     module_id: "f1d86b8e-6b91-4985-b968-a09a1e8906eb",
    //                     user_id: userData?.data?.id || kindeUser?.id,
    //                     can_get_list: true,
    //                     can_get_one: true,
    //                     can_create: true,
    //                     can_update: true,
    //                     can_delete: true,
    //                 },
    //                 {
    //                     module_id: "21b8924c-7846-41de-bfde-6cb4e20a13ed",
    //                     user_id: userData?.data?.id || kindeUser?.id,
    //                     can_get_list: true,
    //                     can_get_one: true,
    //                     can_create: true,
    //                     can_update: true,
    //                     can_delete: true,
    //                 },
    //                 {
    //                     module_id: "71794f22-dd53-4d78-9e75-acbc54714e6c",
    //                     user_id: userData?.data?.id || kindeUser?.id,
    //                     can_get_list: true,
    //                     can_get_one: true,
    //                     can_create: true,
    //                     can_update: true,
    //                     can_delete: true,
    //                 },
    //                 {
    //                     module_id: "4d200895-4571-4ee6-80d9-16367aceb3a4",
    //                     user_id: userData?.data?.id || kindeUser?.id,
    //                     can_get_list: true,
    //                     can_get_one: true,
    //                     can_create: true,
    //                     can_update: true,
    //                     can_delete: true,
    //                 },
    //                 {
    //                     module_id: "de69ca63-ecae-4256-a7be-1ff17832cbce",
    //                     user_id: userData?.data?.id || kindeUser?.id,
    //                     can_get_list: true,
    //                     can_get_one: true,
    //                     can_create: true,
    //                     can_update: true,
    //                     can_delete: true,
    //                 },
    //                 {
    //                     module_id: "d35da011-6589-4032-b14e-10f677b0013c",
    //                     user_id: userData?.data?.id || kindeUser?.id,
    //                     can_get_list: true,
    //                     can_get_one: true,
    //                     can_create: true,
    //                     can_update: true,
    //                     can_delete: true,
    //                 },
    //                 {
    //                     module_id: "99e1ca6b-d8e2-427d-887a-eccca89d0939",
    //                     user_id: userData?.data?.id || kindeUser?.id,
    //                     can_get_list: true,
    //                     can_get_one: true,
    //                     can_create: true,
    //                     can_update: true,
    //                     can_delete: true,
    //                 },
    //                 {
    //                     module_id: "79feddb9-6826-4ee7-8e09-b6500a4cd268",
    //                     user_id: userData?.data?.id || kindeUser?.id,
    //                     can_get_list: true,
    //                     can_get_one: true,
    //                     can_create: true,
    //                     can_update: true,
    //                     can_delete: true,
    //                 },
    //                 {
    //                     module_id: "94a47ed9-15cd-457c-9ef4-a4c85856bfb0",
    //                     user_id: userData?.data?.id || kindeUser?.id,
    //                     can_get_list: true,
    //                     can_get_one: true,
    //                     can_create: true,
    //                     can_update: true,
    //                     can_delete: true,
    //                 },
    //                 {
    //                     module_id: "f387835b-0570-4f77-8b39-a4f6aead0e8d",
    //                     user_id: userData?.data?.id || kindeUser?.id,
    //                     can_get_list: true,
    //                     can_get_one: true,
    //                     can_create: true,
    //                     can_update: true,
    //                     can_delete: true,
    //                 },
    //                 {
    //                     module_id: "f2de7f69-7fcd-4ed8-a1b4-e5696327ad46",
    //                     user_id: userData?.data?.id || kindeUser?.id,
    //                     can_get_list: true,
    //                     can_get_one: true,
    //                     can_create: true,
    //                     can_update: true,
    //                     can_delete: true,
    //                 },
    //                 {
    //                     module_id: "e9595fc9-067b-4d1e-a5b2-dcbb59409953",
    //                     user_id: userData?.data?.id || kindeUser?.id,
    //                     can_get_list: true,
    //                     can_get_one: true,
    //                     can_create: true,
    //                     can_update: true,
    //                     can_delete: true,
    //                 },
    //             ],
    //         });
    //     }
    // }, [isSuccess]);

    const { setIsLoading } = useGlobalLoading();

    useEffect(() => {
        if (isAddUserPending || isSuccess || kindeLoading) {
            setIsLoading(true);
        }
    }, [isAddUserPending, isSuccess, kindeLoading, setIsLoading]);

    useEffect(() => {
        return () => {
            setIsLoading(true);
        };
    }, [setIsLoading]);

    return (
        <div>
            <Form {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)} className="grid grid-cols-2 gap-4">
                    <FormField
                        control={form.control}
                        name="firstname"
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel className="text-base">Firstname*</FormLabel>
                                <FormControl>
                                    <Input className="py-6" placeholder="Enter Firstname" {...field} />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                    <FormField
                        control={form.control}
                        name="lastname"
                        render={({ field }) => (
                            <FormItem>
                                <FormLabel className="text-base">Lastname*</FormLabel>
                                <FormControl>
                                    <Input className="py-6" placeholder="Enter Lastname" {...field} />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                    <div className="col-span-2">
                        <FormField
                            control={form.control}
                            name="heared_from"
                            render={({ field }) => (
                                <FormItem>
                                    <FormLabel className="text-base">How did You Here about Shoe Ai Chatbot*</FormLabel>
                                    <FormControl>
                                        <Select onValueChange={(value) => field.onChange(value)} defaultValue={field.value}>
                                            <SelectTrigger className="w-full py-6" id={"heared_from"}>
                                                <SelectValue placeholder="Select an option" />
                                            </SelectTrigger>
                                            <SelectContent>
                                                <SelectGroup>
                                                    <SelectLabel>Options</SelectLabel>
                                                    <SelectItem value="facebook">Facebook</SelectItem>
                                                    <SelectItem value="youtube">Youtube</SelectItem>
                                                    <SelectItem value="linked-in">Linked In</SelectItem>
                                                    <SelectItem value="friends">Friends</SelectItem>
                                                    <SelectItem value="business-partner">Business Partner</SelectItem>
                                                </SelectGroup>
                                            </SelectContent>
                                        </Select>
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                    </div>
                    <div className="col-span-2">
                        <Label className="text-base">Are you transitioning from a different chat platform?</Label>
                        <RadioGroup
                            defaultValue="no"
                            className="mt-4 flex items-center gap-2"
                            value={isPrevBot}
                            onValueChange={(value) => setIsPrevBot(value)}
                        >
                            <div className="flex items-center space-x-2">
                                <RadioGroupItem value="yes" id="r1" />
                                <Label htmlFor="r1" className="text-base">
                                    Yes
                                </Label>
                            </div>
                            <div className="flex items-center space-x-2">
                                <RadioGroupItem value="no" id="r2" />
                                <Label htmlFor="r2" className="text-base">
                                    No
                                </Label>
                            </div>
                        </RadioGroup>
                    </div>
                    {isPrevBot === "yes" && (
                        <div className="col-span-2">
                            <FormField
                                control={form.control}
                                name="prev_bot"
                                render={({ field }) => (
                                    <FormItem>
                                        <FormLabel className="text-base">Which Chat Platform are You Moving away from?</FormLabel>
                                        <FormControl>
                                            <Input className="py-6" placeholder="Enter Chatbot Name" {...field} />
                                        </FormControl>
                                        <FormMessage />
                                    </FormItem>
                                )}
                            />
                        </div>
                    )}
                    <div className="col-span-2 flex justify-end">
                        <Button type="submit">Next</Button>
                    </div>
                </form>
            </Form>
        </div>
    );
};

export default UserInfoForm;
